import { cloneMap, DataModel, DataModelBuilder, isSameData,
  isSameMap, mapToData, SerializationContext, SerializedData } from '../dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { PriceRange } from './price-range.js';
import { Currency } from '../serializable/currency.js';

export class DailyStatistics extends DataModel {
  static readonly TYPE_ID: string = '387dcdd7741d43739dfc1a9688abd96a';

  constructor(
    public readonly ordersPerService: Map<string, number>,
    public readonly incomePerService: Map<string, PriceRange>,
    public readonly currency: Currency,
  ) {
    super();
  }

  get $typeId(): string {
    return DailyStatistics.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): DailyStatistics {
    return new DailyStatistics(
        MapUtils.getMap<string, number>(map, 'ordersPerService', (k, v) => {
          return { key: k, value: Number(v) };
        }),
        MapUtils.getMap<string, PriceRange>(map, 'incomePerService', (k, v) => {
          return { key: k, value: context.fromData<PriceRange>(v as SerializedData) };
        }),
        MapUtils.get<Currency>(map, 'currency'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'ordersPerService': mapToData(this.ordersPerService, (k, v) => {
        return { key: k.toString(), value: v };
      }),
      'incomePerService': mapToData(this.incomePerService, (k, v) => {
        return { key: k, value: context.toData(v) };
      }),
      'currency': this.currency,
    };
  }

  clone(): this {
    return new DailyStatistics(
        cloneMap(this.ordersPerService),
        cloneMap(this.incomePerService),
        this.currency,
    ) as this;
  }

  isSame(other: DailyStatistics) {
    if(this === other) {
      return true;
    }

    return isSameMap(other.ordersPerService, this.ordersPerService) &&
      isSameMap(other.incomePerService, this.incomePerService, isSameData) &&
      other.currency === this.currency;
  }
}

export class DailyStatisticsBuilder extends DataModelBuilder<DailyStatistics> {
  build(context: SerializationContext, map: SerializedData): DailyStatistics {
    return DailyStatistics.fromMap(context, map);
  }
}
